import { gql } from "@apollo/client";

export const GET_SELLER_PROFILE = gql`
  query {
    getSellerProfile {
      success
      message
      data {
        seller_id
        email
        banner_pic
        logo_pic
        sid
        created_at
        updated_at
        contact_number
        shop_title
        shop_url
        name
        is_seller
        company_description
        return_policy
        shipping_policy
        privacy_policy
        firstname
        lastname
        contract_doc
        patente_doc
        rne_doc
        cin_recto_doc
        cin_verso_doc
        rib_doc
        contract_doc_validation
        patente_doc_validation
        rne_doc_validation
        cin_recto_doc_validation
        cin_verso_doc_validation
        rib_doc_validation
        others_info
        taxvat
        billing_street
        billing_city
        billing_region
        billing_postcode
        billing_country_id
        twitter_id
        instagram_id
        facebook_id
        youtube_id
        pinterest_id
      }
    }
  }
`;
